import React, { Component, PropTypes } from "react";
import "./Login.css";
import { getUser, getLogin, CheckUser, getGeoInfo } from "../../Model/Users"; //Include Home
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { isMobile } from "react-device-detect";
import {
  Encrypt,
  withRouter,
  VirsionCheck,
  SVGIcons,
  ImgIcons,
  makeid,
  Appsflyer,
} from "../../Helpers/Common"; //Include Home
import * as CountryCode from "../../Config/CountryCode.js";
import { motion } from "framer-motion";
import { Metadata } from "../Metadata/Metadata";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import BarLoader from "react-spinners/BarLoader";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Login extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);

    this.state = {
      fields: {
        fld_mobile: "",
        country_code: "",
        fld_email: "",
        fld_password: "",
      },
      errors: {
        isValidEmailerror: false,
        isValidMobileerror: false,
        isValidPassworderror: false,
      },
      isValidEmail: false,
      isValidMobile: false,
      isValidPassword: false,
      msg: { validcredentials: false },
      VirsionCheckData: [],
      LoginButton: false,
      VirsionCheckDataloaded: false,
      showpassword: false,
      country: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.submituserLoginForm = this.submituserLoginForm.bind(this);
  }

  componentDidMount() {
    getGeoInfo().then((res) => {
      this.setState({
        country: res,
      });
      localStorage.setItem("country",res)

    });

    VirsionCheck().then((vcheckres) => {
      if (localStorage.getItem("SessId") == null) {
        makeid(15).then((res) => {
          localStorage.setItem("SessId", res);
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
          });
        });
      } else {
        this.setState({
          VirsionCheckData: vcheckres,
          VirsionCheckDataloaded: true,
        });
      }
    });
  }

  Showpassword() {
    var checkcurrentState = this.state.showpassword;
    if (checkcurrentState) {
      this.setState({
        showpassword: false,
      });
    } else {
      this.setState({
        showpassword: true,
      });
    }
  }

  submituserLoginForm(e) {
    Appsflyer("login", {});
    e.preventDefault();
    var postdata = {
      fld_email: this.state.fields.fld_email,
      fld_password: this.state.fields.fld_password,
      fld_mobile: this.state.fields.fld_mobile,
      countryCode: this.state.fields.country_code,
      country: this.state.country,
      SessId: localStorage.getItem("SessId"),
    };

    getLogin(postdata).then((res) => {
      if (res.data) {
        /*Check User Success Login*/
        var proutes = localStorage.getItem("route");
        if (proutes) {
          this.props.navigate("/" + proutes);
        }
        var LoginResponse = JSON.parse(res.data.body);

        if (LoginResponse.success == false) {
          /*Error While Signup*/
          var setMsg = this.state.msg;
          setMsg["validcredentials"] = LoginResponse.message;

          var setError = this.state.errors;

          if (this.state.fields.fld_mobile != "") {
            setError["isValidMobileerror"] = true;
          } else {
            setError["isValidEmailerror"] = true;
          }

          setError["isValidPassworderror"] = true;
          this.setState({
            setError,
          });
        } else {
          Encrypt(LoginResponse).then((res) => {
            if (LoginResponse.success == true) {
              localStorage.setItem("user-info", JSON.stringify(res));
              this.setState({
                logindetails: res,
                formSubmitted: true,
              });
              this.setState({
                Redirect: true,
              });
              Appsflyer("login", {});
              console.log("redirect to home page from login poage");
            }
          });
        }
      } else {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        formIsValid = false;
        errors["fld_password"] = "*Incorrect Password.";
        this.setState({
          errors: errors,
        });
        return formIsValid;
      }
    });
  }

  handleChange(e) {
    const fields = this.state.fields;
    var Valuespost = e.target.name;

    var setMsg = this.state.msg;
    setMsg["validcredentials"] = false;
    this.setState({ setMsg });

    var errorState = this.state.errors;
    errorState["isValidEmailerror"] = false;
    errorState["isValidPassworderror"] = false;
    errorState["isValidMobileerror"] = false;

    this.setState({ errorState });

    if (e.target.name == "fld_email") {
      const isValid = this.state.isValid;
      const emailRegex = /\S+@\S+\.\S+/;
      if (
        emailRegex.test(e.target.value) &&
        /\s/.test(e.target.value) == false
      ) {
        //Set State For Valid email
        this.setState({
          isValidEmail: true,
        });
        //Already Register Error Removed
        var errorState = this.state.errors;
        errorState["isValidEmailerror"] = false;
        this.setState({ errorState });
      } else {
        this.setState({
          isValidEmail: false,
        });
      }
    } else if (e.target.name == "fld_password") {
      var isValidPassword = this.state.fields;
      if (e.target.value.length >= 6) {
        var validPasswordMsg = this.state.errors;
        validPasswordMsg["isValidPassworderror"] = false;
        this.setState({
          errorState,
          isValidPassword: true,
          validPasswordMsg,
        });
      } else {
        var validPasswordMsg = this.state.errors;
        validPasswordMsg["isValidPassworderror"] = false;
        this.setState({
          validPasswordMsg,
          isValidPassword: false,
        });
      }
    } else if (
      e.target.name == "fld_mobile" &&
      /\s/.test(e.target.value) == false
    ) {
      const isValidMobile = this.state.isValidMobile;
      var errorState = this.state.errors;
      errorState["isValidMobileerror"] = false;
      this.setState({ errorState });
      if (
        e.target.value.length >= 6 &&
        e.target.value.length <= 15 &&
        !isNaN(e.target.value)
      ) {
        this.setState({
          isValidMobile: true,
        });
      } else {
        this.setState({
          isValidMobile: false,
        });
      }
    }
    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }

  render() {
    if (this.state.Redirect == true) {
      if (sessionStorage.getItem("refferalUrl")) {
        this.props.navigate(sessionStorage.getItem("refferalUrl"));
        sessionStorage.removeItem("refferalUrl");
      } else {
        this.props.navigate("/");
      }
    }
    if (
      (this.state.isValidEmail && this.state.isValidPassword) ||
      (this.state.isValidMobile && this.state.isValidPassword)
    ) {
      var fenable = false;
    } else {
      var fenable = true;
    }

    if (this.state.isValidEmail) {
      var fld_email = false;
      var fld_mobile = true;
    } else if (this.state.isValidMobile) {
      var fld_email = true;
      var fld_mobile = false;
    } else {
      var fld_email = false;
      var fld_mobile = false;
    }

    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      var BannerData = JSON.parse(this.state.VirsionCheckData.data).data
        .banner_images;
      var logintext = BannerData.signin_step_1_1.text_four.split("<br />");

      return (
        <>
          <Metadata page="LOGIN" />
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <div className="dD-none">
              <header>
                <div className="mainNav">
                  <div className="docubayLogo">
                    <img
                      src={ImageData["docu-bay-white.png"]}
                      alt="DocuBay Logo"
                    />
                  </div>
                  <div className="topQuestion">
                    {/*<img src={SVGIcon['help.svg']} alt="help" />*/}
                  </div>
                </div>
              </header>
              <main>
                <section>
                  <div className="homeBanner">
                    <div className="innerBanner">
                      <picture>
                        <source
                          srcSet={BannerData.signin_step_1_1.ipad_banner_image}
                          media="(min-width: 700px)"
                        />
                        <source
                          srcSet={BannerData.signin_step_1_1.ipad_banner_image}
                          media="(min-width: 768px)"
                        />
                        <source
                          srcSet={BannerData.signin_step_1_1.banner_image_url}
                          media="(min-width: 650px)"
                        />
                        <source
                          srcSet={BannerData.signin_step_1_1.banner_image_url}
                          media="(min-width: 300px)"
                        />
                        <img
                          src={BannerData.signin_step_1_1.banner_image_url}
                        />
                      </picture>
                      <div className="title">
                        <h1 className="mb-20">
                          {BannerData.signin_step_1_1.text_two}{" "}
                          <span className="red">
                            {BannerData.signin_step_1_1.text_three}{" "}
                          </span>
                        </h1>
                        <h2 className="line-height">
                          {logintext["0"]}
                          <br />
                          {logintext[1]}
                        </h2>
                      </div>
                    </div>
                  </div>
                </section>
                <form
                  className="login_form"
                  method="post"
                  name="loginformidv2"
                  onSubmit={this.submituserLoginForm}
                  noValidate="novalidate"
                >
                  <section style={{ paddingBottom: 45 }}>
                    <div className="temp1">
                      <div className="temp1Head">
                        <h2>Enter details</h2>
                        <h6>
                          Resume watching documentaries from around the world.
                        </h6>
                      </div>
                      <div className="temp1Inner">
                        <div
                          className={
                            this.state.fields.fld_mobile
                              ? "formField disable-fild"
                              : "formField"
                          }
                        >
                          <input
                            type="text"
                            name="fld_email"
                            placeholder="Enter email address"
                            className={
                              this.state.errors.isValidEmailerror
                                ? "error-border"
                                : null
                            }
                            value={this.state.fields.fld_email}
                            onChange={this.handleChange}
                            autoComplete="on"
                            textcontenttype="none"
                            autoCorrect="false"
                            minLength="6"
                            maxLength="50"
                            disabled={
                              this.state.fields.fld_mobile.length ? true : false
                            }
                          />
                        </div>
                        <div className="temp1Or"> OR </div>
                        <div
                          className={
                            this.state.errors.isValidMobileerror
                              ? " formField error-border data"
                              : this.state.fields.fld_email
                                ? "formField data disable-fild"
                                : "formField data "
                          }
                          ref={this.emailInput}
                        >
                          <select
                            name="country_code"
                            className="selectTel"
                            onChange={this.handleChange}
                            disabled={
                              this.state.fields.fld_email ? true : false
                            }
                          >
                            {CountryCode.Countrycode.map((CoutryData) => {
                              return (
                                <option
                                  key={CoutryData.name}
                                  value={CoutryData.dial_code}
                                >
                                  {CoutryData.dial_code}
                                </option>
                              );
                            })}
                          </select>
                          <input
                            name="fld_mobile"
                            type="tel"
                            className="inputTel"
                            placeholder="Enter mobile number"
                            value={this.state.fields.fld_mobile}
                            onChange={this.handleChange}
                            disabled={
                              this.state.fields.fld_email.length ? true : false
                            }
                            pattern="[0-9]"
                            textcontenttype="none"
                            autoCorrect="false"
                            minLength="6"
                            maxLength="15"
                            autoComplete="on"
                            required
                          />
                        </div>

                        <div className="formField">
                          <span
                            className="password-hidden-img"
                            onClick={() => {
                              this.Showpassword();
                            }}
                          >
                            <img
                              src={
                                this.state.showpassword
                                  ? "./img/svg/password-exposed.svg"
                                  : "./img/svg/password-hidden.svg"
                              }
                              alt="DocuBay"
                            />
                          </span>

                          <input
                            type={this.state.showpassword ? "text" : "password"}
                            name="fld_password"
                            id="fld_currentpwd"
                            className={
                              this.state.errors.isValidPassworderror
                                ? "password-hidden error-border"
                                : "password-hidden"
                            }
                            placeholder="Enter password"
                            value={this.state.fields.fld_password}
                            onChange={this.handleChange}
                            minLength="6"
                            maxLength="60"
                            autoComplete="on"
                          />
                          <div className="forgot-Pass">
                            <Link to="/forgot-password">
                              <p>Forgot password?</p>
                            </Link>
                          </div>
                          {this.state.msg.validcredentials ? (
                            <div className="error">
                              <img
                                src={
                                  process.env.PUBLIC_URL + "img/svg/error.svg"
                                }
                                alt="DocuBay"
                              />
                              <p>{this.state.msg.validcredentials} </p>
                            </div>
                          ) : null}
                        </div>
                        <div className="formField mt-24 mb-24">
                          <button
                            type="submit"
                            disabled={fenable}
                            className={fenable ? "btn-black" : "btn-red"}
                          >
                            Log in
                          </button>
                        </div>
                        <div className="temp1Login">
                          New to DocuBay?{" "}
                          <Link className="whiteLogin" to="/createaccount">
                            Create account
                          </Link>
                        </div>
                      </div>
                    </div>
                  </section>
                </form>
              </main>
            </div>

            <div className="dD-block">
              <header>
                <div className="mainNav pmenu policy-left">
                  <div className="docubayLogo">
                    <img
                      src={ImageData["docu-bay-white.png"]}
                      alt="DocuBay Logo"
                    />
                  </div>
                </div>
              </header>
              <form
                className="login_form"
                method="post"
                name="loginformidv2"
                onSubmit={this.submituserLoginForm}
                noValidate="novalidate"
              // autoComplete="on"
              >
                <div className="tempLogin">
                  <div className="temp1Head">
                    <h2>Enter details</h2>
                    <h6>
                      Resume watching documentaries from around the world.
                    </h6>
                  </div>

                  <div className="temp1Inner">
                    <div
                      className={
                        this.state.fields.fld_mobile
                          ? "formField disable-fild"
                          : "formField"
                      }
                    >
                      <input
                        type="text"
                        name="fld_email"
                        id="fld_email"
                        placeholder="Enter email address"
                        className={
                          this.state.errors.isValidEmailerror
                            ? "error-border"
                            : null
                        }
                        value={this.state.fields.fld_email}
                        onChange={this.handleChange}
                        autoComplete="on"
                        textcontenttype="none"
                        autoCorrect="false"
                        minLength="6"
                        maxLength="50"
                        disabled={
                          this.state.fields.fld_mobile.length ? true : false
                        }
                      />
                    </div>
                    <div className="temp1Or"> OR </div>
                    <div
                      className={
                        this.state.errors.isValidMobileerror
                          ? " formField error-border data"
                          : this.state.fields.fld_email
                            ? "formField data disable-fild"
                            : "formField data "
                      }
                      ref={this.emailInput}
                    >
                      <select
                        name="country_code"
                        className="selectTel1"
                        onChange={this.handleChange}
                        disabled={this.state.fields.fld_email ? true : false}
                      >
                        {CountryCode.Countrycode.map((CoutryData) => {
                          return (
                            <option
                              key={CoutryData.name}
                              value={CoutryData.dial_code}
                            >
                              {CoutryData.dial_code}
                            </option>
                          );
                        })}
                      </select>
                      <input
                        name="fld_mobile"
                        type="tel"
                        id="fld_mobile"
                        className="inputTel"
                        placeholder="Enter mobile number"
                        value={this.state.fields.fld_mobile}
                        onChange={this.handleChange}
                        disabled={
                          this.state.fields.fld_email.length ? true : false
                        }
                        textcontenttype="none"
                        autoCorrect="false"
                        minLength="6"
                        maxLength="15"
                        pattern="[0-9]"
                        autoComplete="on"
                        required
                      />
                    </div>

                    <div className="formField">
                      <span
                        className="password-hidden-img"
                        onClick={() => {
                          this.Showpassword();
                        }}
                      >
                        <img
                          src={
                            this.state.showpassword
                              ? "./img/svg/password-exposed.svg"
                              : "./img/svg/password-hidden.svg"
                          }
                          alt="DocuBay"
                        />
                      </span>

                      <input
                        type={this.state.showpassword ? "text" : "password"}
                        name="fld_password"
                        id="fld_currentpwd"
                        className={
                          this.state.errors.isValidPassworderror
                            ? "password-hidden error-border"
                            : "password-hidden"
                        }
                        placeholder="Enter password"
                        value={this.state.fields.fld_password}
                        onChange={this.handleChange}
                        minLength="6"
                        maxLength="60"
                        autoComplete="on"
                      />
                      <div className="forgot-Pass">
                        <Link to="/forgot-password">
                          <p>Forgot password?</p>
                        </Link>
                      </div>
                      {this.state.msg.validcredentials ? (
                        <div className="error">
                          <img
                            src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                            alt="DocuBay"
                          />
                          <p>{this.state.msg.validcredentials} </p>
                        </div>
                      ) : null}
                    </div>
                    <div className="formField mt-24 mb-24">
                      <button
                        type="submit"
                        disabled={fenable}
                        className={fenable ? "btn-black" : "btn-red"}
                      >
                        Log in
                      </button>
                    </div>
                    <div className="temp1Login">
                      New to DocuBay?{" "}
                      <Link className="whiteLogin" to="/createaccount">
                        Create account
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
              <div className="banner-overlay-7"></div>

              <div className="marqueeHead2">
                <div className="marquee-section-login">
                  <div className="marquee-login">
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1683030294-apple-the-trillion-dollar-betraya-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1622045318-bitcoin-the-end-of-money-as-we-know-ipad-banner-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1675420962-breathless-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1595419170-christian-dior-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1671180674-circus-stories-episode-living-with-the-lion-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1679056452-cyber-war-2022-1080x1543-540x772.jpg"
                      }
                    />
                  </div>
                  <div aria-hidden="true" className="marquee-login">
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1595421028-eye-to-eye-with-everest-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1667400004-forever-faithful-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1682688058-hitlers-olympics-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1672412514-augmented-h-umanity-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1677246027-hunger-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1595424855-inside-facebook-1080x1543-540x772.jpg"
                      }
                    />
                  </div>
                </div>

                <div className="marquee-section-login1">
                  <div className="marquee-login1">
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1595425286-jaguar-going-electric-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1666187540-mengele-the-hunt-for-a-nazi-criminal-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1675849483-musk-vs-bezos-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1609258181-the-dark-side-of-green-energies-ipad-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1678358585-the-rise-of-ai-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1648137235-the-vietnam-war-1080x1543-540x772.jpg"
                      }
                    />
                  </div>
                  <div aria-hidden="true" className="marquee-login1">
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1609347468-the-world-according-to-amazon-ipad-banner-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1627488871-zara-ipad-banner-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1675416868-democracy-for-sale-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1677849869-inside-nasa-s-innovation-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1677670173-nftme-1080x1543-540x772.jpg"
                      }
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      data-nimg={1}
                      src={
                        "https://dbcms.docubay.com/featured-images/1677759447-tech-talk-1080x1543-540x772.jpg"
                      }
                    />
                  </div>
                </div>
              </div>

              {/* <div className="container1 container1login">
                <img src={SVGIcon['signUP-membership-bg.svg']} />
                <div className="section1 section11">
                  <h3>One membership, three Benefits!</h3>
                  <h2>@only ₹999/-</h2>
                  <div className="img-banner ">
                    <img src={ImageData['signup-benefits.png']} />
                  </div>
                </div>
              </div> */}

              <div className="container2">
                <div className="section2">
                  <h1 className="mb-20">
                    Curated by&nbsp;<span className="red">topics</span>
                  </h1>
                  <p>
                    Introducing a new way to explore the world of
                    <br />
                    documentaries - curated films and series by topics.
                  </p>
                </div>
                <img src={ImageData["SignUp-phone1.png"]} />
              </div>

              <div className="container3">
                <img src={ImageData["SignUp-phone2.png"]} />
                <div className="section3">
                  <h1 className="mb-20">
                    Watch live&nbsp;<span className="red">TV</span>
                  </h1>
                  <p>
                    Tune in at any time of day or night and discover a<br />
                    world of engaging and informative content.
                  </p>
                </div>
              </div>

              <div className="container2 container5">
                <div className="section2">
                  <h1 className="mb-20">
                    Watch&nbsp;<span className="red">DocuBytes</span>
                  </h1>
                  <p>
                    Quick and entertaining way to learn something <br /> new,
                    from science and technology to lifestyle and <br />{" "}
                    entertainment.
                  </p>
                </div>
                <img src={ImageData["SignUp-phone3.png"]} />
              </div>

              <div className="container4">
                <img src={ImageData["SignUp-phone4.png"]} />
                <div className="section4">
                  <h1 className="mb-20">
                    Download to watch&nbsp;<span className="red">offline</span>
                  </h1>
                  <p>
                    With just a few taps, you can download your
                    <br />
                    favorite films and series on your mobile phone and watch{" "}
                    <br />
                    them offline.
                  </p>
                </div>
              </div>
              <Footerdesk />
            </div>
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Login);
